import AnimationLayout from '@/animation/AnimationLayout';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
  return (
    <>
      <div
        className="min-h-screen text-white flex flex-col p-5 overflow-hidden"
        style={{
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* <AnimationLayout /> */}
        {/* Rotated background image */}
        {/* <div
          className="absolute inset-0 z-0  origin-center"
         
        /> */}

        {/* Logo */}
        {/* <img src={`${imagekit}/login/logo.svg`} alt="" className="w-40 relative z-10" /> */}

        {/* Centered Section */}
        <AnimationLayout>
          <div className="flex-grow flex-center relative z-10">
            <div className="flex items-center justify-center">
              <img src="/images/logo.webp" alt="logo" className="w-60 mx-10 " />
            </div>
            <div className="relative max-w-[560px] w-full mx-auto flex-center flex-col">
              {/* <img src={`${imagekit}/login/logo.svg`} alt="" className="w-80 relative z-10 mb-10" /> */}
              <Outlet />
            </div>
          </div>
        </AnimationLayout>
      </div>
    </>
  );
}
